import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { LuFileCheck } from 'react-icons/lu'
import LogoSah from '../../../../assets/LogoSah.png'

export const AjusteConfirmacao: React.FC = () => {
  return (
    <Flex direction={'row'} py={'2rem'} alignItems={'center'} justifyContent={'center'} h={'100vh'} bgColor={'gray.100'} >

        <Box bgColor={'white'} flex={1} p={'8rem'} flexDirection={'column'} display={'flex'} alignItems={'center'} pt={'4rem'} >
          {/* Circulo verde */}
            <img src={LogoSah} width={'360px'} />

          <Box bgColor={'green.300'} my={'2rem'} p={'1.2rem'} borderRadius={'full'} >
            <LuFileCheck size={50} color={'white'}/>
          </Box>
          <Heading fontWeight={'semibold'}>Solicitação de ajuste enviada com sucesso!</Heading>
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'2rem'} fontSize={'2xl'} >
            <Text>Suas solicitações foram enviadas e estão em análise.</Text>
            <Text>Você receberá um e-mail com a resposta da área de RH.</Text>
          </Box>

        </Box>
    </Flex>
  )
}
